import React from 'react';
import {Trans} from "react-i18next";
import { Link } from 'react-router-dom';

const BackButton = () => {

    return (
        <>
          <Link  style={{ color:'#121127',marginBottom:'10px!important'}} to="/payroll-new/settings" className='text-nowrap'>
            <i className="fa fa-arrow-left mr-1" style={{color:'#72B566', fontSize:'16px'}} aria-hidden="true"></i> 
            <Trans>Back to settings management</Trans>
        </Link> 
        </>
    );
}

export default BackButton;
